import React from 'react';
import { Helmet } from 'react-helmet-async';
import { COMPANY_INFO } from '../mock';

const FAQ_ITEMS_KONTAKT = [
  {
    question: 'Wie schnell bekomme ich eine Rückmeldung?',
    answer: 'Sehr schnell. Rufen Sie an oder schreiben Sie per WhatsApp – wir melden uns zeitnah zurück.'
  },
  {
    question: 'Kann ich auch abends oder am Wochenende schreiben?',
    answer: 'Ja. Schreiben Sie uns über WhatsApp, auch außerhalb der üblichen Geschäftszeiten. Wir antworten so schnell wie möglich.'
  },
  {
    question: 'Muss ich etwas vorbereiten?',
    answer: 'Es hilft, wenn Sie Unfalltag, Schadenart und Standort des Fahrzeugs wissen. Aber keine Sorge – wenn etwas fehlt, klären wir das im Gespräch.'
  },
  {
    question: 'Kommt ihr direkt vor Ort?',
    answer: 'Ja. Die Begutachtung findet dort statt, wo sich Ihr Fahrzeug befindet – bundesweit.'
  },
  {
    question: 'Was passiert nach der Kontaktaufnahme?',
    answer: 'Wir klären Ihre Situation, geben eine erste Einschätzung und vereinbaren bei Bedarf einen Termin vor Ort.'
  },
  {
    question: 'Kann ich auch nur eine kurze Frage stellen?',
    answer: 'Selbstverständlich. Rufen Sie an oder schreiben Sie kurz – wir helfen Ihnen gerne weiter, auch wenn Sie sich noch nicht sicher sind.'
  },
  {
    question: 'Ist die Erstberatung kostenlos?',
    answer: 'Die erste Kontaktaufnahme und Einschätzung ist unverbindlich. Wir klären gemeinsam, welche Schritte für Sie sinnvoll sind.'
  },
  {
    question: 'Welcher Kontaktweg ist am schnellsten?',
    answer: 'Telefonisch erreichen Sie uns am direktesten. Per WhatsApp können Sie jederzeit schreiben – auch außerhalb der üblichen Zeiten.'
  }
];

export const SEOHeadKontakt = () => {
  const schemaBreadcrumb = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Startseite",
        "item": "https://www.dein-gutachten-direkt.de/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Kontakt",
        "item": "https://www.dein-gutachten-direkt.de/kontakt"
      }
    ]
  };

  const schemaFAQ = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": FAQ_ITEMS_KONTAKT.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>Kontakt | Unfallgutachten bundesweit | Dein Gutachten Direkt</title>
      <meta name="title" content="Kontakt | Unfallgutachten bundesweit | Dein Gutachten Direkt" />
      <meta name="description" content="Kontaktieren Sie uns per Telefon oder WhatsApp. Schnelle Abstimmung, bundesweite Begutachtung, unabhängige Unfallgutachten." />
      <meta name="keywords" content="Kontakt Unfallgutachten, Gutachter kontaktieren, Telefon, WhatsApp, bundesweit" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.dein-gutachten-direkt.de/kontakt" />
      <meta property="og:title" content="Kontakt | Unfallgutachten bundesweit" />
      <meta property="og:description" content="Kontaktieren Sie uns per Telefon oder WhatsApp. Schnelle Abstimmung, bundesweite Begutachtung." />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://www.dein-gutachten-direkt.de/kontakt" />
      <meta property="twitter:title" content="Kontakt | Unfallgutachten bundesweit" />
      <meta property="twitter:description" content="Kontaktieren Sie uns per Telefon oder WhatsApp" />

      {/* Canonical */}
      <link rel="canonical" href="https://www.dein-gutachten-direkt.de/kontakt" />

      {/* Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify(schemaBreadcrumb)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(schemaFAQ)}
      </script>
    </Helmet>
  );
};